<template>
  <div>
    <embedded-header></embedded-header>
    <div class="container pt-5 mt-5">
      <div class="row">
        <div class="col-12 text-center">
          <span><i class="bi bi-check-circle-fill text-success mr-2"></i>The bookmark was saved successfully.</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EmbeddedHeader from "@/components/EmbeddedHeader";

export default {
  name: "EmbeddedOkThxBai",
  components: {EmbeddedHeader}
}
</script>

<style scoped>

</style>
